import Moment from "moment";

export class DatesUtils {

    static formatDate(date) {
        if (date == null || date.length === 0) return "-";

        let hasHour = DatesUtils.hasHour(date);

        let txt;
        if (DatesUtils.isToday(date)) {
            txt = ucfirst(Lang.get("nombres.hoy"));
        } else if (DatesUtils.isYesterday(date)) {
            txt = ucfirst(Lang.get("nombres.ayer"));
        } else if (DatesUtils.isThisYear(date)) {
            txt = DatesUtils.onlyDayMonth(date);
        } else {
            txt = DatesUtils.onlyDateCorto(date);
        }

        if (hasHour) txt += " " + DatesUtils.onlyHour(date);
        return txt;
    }

    /**
     * @param date
     * @returns {boolean}
     */
    static isToday(date) {
        let fechaMoment = Moment(date, "YYYY-MM-DD HH:mm:ss");
        let nowMoment = Moment();

        if (!fechaMoment.isValid()) return false;

        return fechaMoment.year() === nowMoment.year() && fechaMoment.dayOfYear() === nowMoment.dayOfYear();
    }

    /**
     * @param date
     * @returns {boolean}
     */
    static isYesterday(date) {
        let fechaMoment = Moment(date, "YYYY-MM-DD HH:mm:ss");
        let nowMoment = Moment();

        if (!fechaMoment.isValid()) return false;

        return fechaMoment.year() === nowMoment.year() && fechaMoment.dayOfYear() === nowMoment.dayOfYear() - 1;
    }

    /**
     * @param date
     * @returns {boolean}
     */
    static isThisYear(date) {
        let fechaMoment = Moment(date, "YYYY-MM-DD HH:mm:ss");
        let nowMoment = Moment();

        if (!fechaMoment.isValid()) return false;

        return fechaMoment.year() === nowMoment.year();
    }

    /**
     * @param date
     * @returns string
     */
    static extractDate(date) {
        let fechaMoment = Moment(date, "YYYY-MM-DD HH:mm:ss");

        if (!fechaMoment.isValid()) return false;

        return fechaMoment.format("YYYY-MM-DD");
    }

    /**
     * @param date
     * @returns string
     */
    static onlyDate(date) {
        let fechaMoment = Moment(date, "YYYY-MM-DD HH:mm:ss");

        if (!fechaMoment.isValid()) return false;

        return fechaMoment.format("DD/MM/YYYY");
    }

    /**
     * @param date
     * @returns string
     */
    static onlyDateCorto(date) {
        let fechaMoment = Moment(date, "YYzYY-MM-DD HH:mm:ss");

        if (!fechaMoment.isValid()) return false;

        return fechaMoment.format("DD/MM/YY");
    }

    /**
     * @param date
     * @returns string
     */
    static onlyDayMonth(date) {
        let fechaMoment = Moment(date, "YYYY-MM-DD HH:mm:ss");

        if (!fechaMoment.isValid()) return false;

        return fechaMoment.format("DD/MM");
    }

    /**
     * @param date
     * @returns string
     */
    static onlyHour(date) {
        let fechaMoment = Moment(date, "YYYY-MM-DD HH:mm:ss");

        if (!fechaMoment.isValid()) return false;

        return fechaMoment.format("HH:mm");
    }

    /**
     * @param date
     * @returns string
     */
    static fullDate(date) {
        let fechaMoment = Moment(date, "YYYY-MM-DD HH:mm:ss");

        if (!fechaMoment.isValid()) return false;

        return fechaMoment.format("DD/MM/YYYY HH:mm:ss");
    }

    static hasHour(date) {
        return date.split(" ").length > 0
    }

    static copyObject(object) {
        return JSON.parse(JSON.stringify(object));
    }

    static convertStringToDate(date) {
        let fechaMoment = Moment(date, "YYYY-MM-DD HH:mm:ss");
        return fechaMoment.toDate();
    }

    static lt(date, secondDate) {
        let dateMoment = Moment(date, "YYYY-MM-DD HH:mm:ss");
        let secondDateMoment = Moment(secondDate, "YYYY-MM-DD HH:mm:ss");

        return dateMoment.isBefore(secondDateMoment);
    }

    static isSameDay(date, secondDate) {
        let dateMoment = Moment(date, "YYYY-MM-DD HH:mm:ss");
        let secondDateMoment = Moment(secondDate, "YYYY-MM-DD HH:mm:ss");

        return dateMoment.diff(secondDateMoment, 'days') === 0;
    }

    /**
     * @param date
     * @returns string
     */
    static weekDayWeb(date) {
        let fechaMoment = Moment(date, "YYYY-MM-DD HH:mm:ss");

        if (!fechaMoment.isValid()) return "-";

        return fechaMoment.format("ddd");
    }
}